import { component } from 'picoapp';

export default component(async (node) => {
  const content = node.querySelector('[data-content]');
  const acceptButton = node.querySelector('[data-accept]');
  const denyButton = node.querySelector('[data-deny]');

  denyButton.addEventListener('click', () => {
    node.setAttribute('data-active', 'false');
  });

  acceptButton.addEventListener('click', () => {
    window.location.href = '/checkout';
  });

  document.addEventListener('click', (event:any) => {
    if (!content.contains(event.target)) {
      node.setAttribute('data-active', 'false');
    }
  });

  document.addEventListener('cart:terms:open', () => {
    setTimeout(() => {
      node.setAttribute('data-active', 'true');
    }, 0);
  });
});
